import classNames from "classnames";
import React from "react";
import settingsStyles from "../../styles/settings.css";
import styles from "./textButton.css";

interface Props extends React.HTMLProps<HTMLDivElement> {
  text: string;
}
export const TextButton = ({ text, className, ...rest }: Props) => {
  return (
    <div {...rest} className={classNames(settingsStyles["text-clickable"], styles.text, className)}>
      {text}
    </div>
  );
};
